import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import _ from 'lodash'

import styles from './MenuSubunidades.module.css'
import {
  atualizarTodasUnidadesAtuais,
  getUnidadesSorted,
  getUnidadesSuperioresAtuais
} from '../../../controllers/unidadesController'
import {
  atualizarFiltros,
  descartarFiltrosSelecionadosMenuFiltros
} from '../../../actions/filtrosActions'

export class MenuSubunidades extends Component {
  handleMarcarDesmarcarTodosCheckboxClick(marcarTodos, unidadeSuperiorAtual) {
    this.props.descartarFiltrosSelecionadosMenuFiltros()
    const subUnidadesByKey = _.keyBy(
      _.concat(unidadeSuperiorAtual, unidadeSuperiorAtual.subunidades),
      (item) => item.codigoUnidade
    )
    const unidadesAtuais = marcarTodos
      ? subUnidadesByKey
      : _.keyBy([unidadeSuperiorAtual], (item) => item.codigoUnidade)
    atualizarTodasUnidadesAtuais(unidadesAtuais)
    this.props.atualizarFiltros({ unidadesAtuais })
    this.setState({ filtrarPor: '' })
    this.redirect()
  }

  redirect() {
    const {
      history,
      history: {
        location: { pathname }
      }
    } = this.props
    if (pathname !== '/') {
      history.push('/')
    }
  }

  render() {
    const {
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidades },
      handleCheckboxClick
    } = this.props
    const unidadesSuperioresAtuais = getUnidadesSuperioresAtuais(_.values(unidadesAtuais), unidades)
    if (_.size(unidadesSuperioresAtuais) !== 1) {
      return null
    }
    const unidadeSuperiorAtual = _.head(unidadesSuperioresAtuais)
    const selecionarTodos = _.size(unidadeSuperiorAtual.subunidades) < _.size(unidadesAtuais)
    const subunidadesOrdenadas = getUnidadesSorted(unidadeSuperiorAtual.subunidades)
    return (
      <Grid container alignContent='flex-start'>
        <Typography
          variant='body1'
          color='textSecondary'
          id='menu-subunidades-title'
          style={{ height: 48, lineHeight: 3, fontWeight: '700' }}>
          Subunidades
        </Typography>
        <Grid item xs={12}>
          <FormControlLabel
            id={`marcar-todas-subunidades`}
            control={
              <Checkbox
                key={_.uniqueId('marcar-todas-subunidades-check-')}
                color='primary'
                value={selecionarTodos}
                checked={Boolean(selecionarTodos)}
                onChange={(event) =>
                  this.handleMarcarDesmarcarTodosCheckboxClick(
                    event.target.checked,
                    unidadeSuperiorAtual
                  )
                }
              />
            }
            label={selecionarTodos ? 'DESMARCAR TODOS' : 'MARCAR TODOS'}
            classes={{ root: styles.marcarTodasSubUnidades }}
          />
        </Grid>
        {_.values(subunidadesOrdenadas).map((subunidade) => (
          <Grid item xs={12} key={_.uniqueId('grid-subunidade-')}>
            <FormControlLabel
              id={`subunidade-${subunidade.sigla.toUpperCase()}`}
              control={
                <Checkbox
                  key={_.uniqueId('subunidade-')}
                  color='primary'
                  value={subunidade.codigoUnidade.toString()}
                  checked={Boolean(unidadesAtuais[subunidade.codigoUnidade])}
                  onChange={(event) => handleCheckboxClick(subunidade, event.target.checked)}
                />
              }
              label={subunidade.nomeReduzido.toUpperCase()}
              classes={{ disabled: styles.unidadesDisabledLabel }}
            />
          </Grid>
        ))}
      </Grid>
    )
  }
}

const mapStateToProps = ({ filtros, unidadesUsuario }) => ({ filtros, unidadesUsuario })

const reduxEnhanced = connect(mapStateToProps, {
  atualizarFiltros,
  descartarFiltrosSelecionadosMenuFiltros
})(MenuSubunidades)

export default withRouter(reduxEnhanced)
